import { RefreshCw } from "lucide-react";

const StatCard = ({ label, value, usd, color, testId }) => (
  <div className="glass-card p-5" data-testid={testId}>
    <p className="text-xs text-[#A0A0A0] uppercase tracking-wider mb-2">{label}</p>
    <p className={`text-2xl font-oswald font-bold ${color}`}>${value.toFixed(2)} <span className="text-sm text-[#A0A0A0]">MXN</span></p>
    <p className="text-sm text-[#A0A0A0] mt-1">${usd} USD</p>
  </div>
);

export const AdminStats = ({ products, exchangeRate, toUSD, onRefreshRate }) => {
  const active = products.filter(p => !p.sold);
  const sold = products.filter(p => p.sold);
  const invested = products.reduce((s, p) => s + (p.buy_price || 0), 0);
  const potential = active.reduce((s, p) => s + ((p.sale_price || 0) - (p.buy_price || 0)), 0);
  const actual = sold.reduce((s, p) => s + ((p.sale_price || 0) - (p.buy_price || 0)), 0);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <StatCard label="Invertido" value={invested} usd={toUSD(invested)} color="text-white" testId="stat-invested" />
        <StatCard label="Ganancia Potencial" value={potential} usd={toUSD(potential)} color="text-[#B026FF]" testId="stat-potential" />
        <StatCard label="Ganancia Real" value={actual} usd={toUSD(actual)} color="text-[#00FF66]" testId="stat-profit" />
      </div>
      <div className="flex items-center gap-2 mb-6 text-xs text-[#A0A0A0]">
        <span>1 USD = ${exchangeRate.toFixed(2)} MXN</span>
        <button onClick={onRefreshRate} className="hover:text-[#00FF66] transition-colors" title="Actualizar tasa" data-testid="refresh-rate-btn">
          <RefreshCw className="w-3 h-3" />
        </button>
      </div>
    </>
  );
};
